import { render, staticRenderFns } from "./add-route-form.vue?vue&type=template&id=62a70cbd&"
import script from "./add-route-form.vue?vue&type=script&lang=ts&"
export * from "./add-route-form.vue?vue&type=script&lang=ts&"
import style0 from "./add-route-form.vue?vue&type=style&index=0&id=62a70cbd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports